export default __webpack_public_path__ + "static/media/light_level.39fa92f5.svg";